import React, { Suspense, useContext, useState } from "react";
import LayoutDashboard from "layouts/layout-dashboard-collapse"; // Assuming this is a layout component
import FullLoader from "components/loader/full-loader";
import { Dropdown } from "react-bootstrap";
import { useDeleteData, useFetchData } from "hooks/useApiHooks";
import { AppContext } from "contexts/AppContext";
import { useCanvasHandler } from "hooks/useCanvasHandler";
import { buildQueryString } from "utils/queryHelpers";
import { usePaginationWithComponent } from "hooks/usePaginationWithComponent";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";

const MetricCard = ({ title, value, currency, comparison }) => {
  return (
    // <div className="col-md-auto col-12 mb-3 ">
    //   <div
    //     className="shadow-sm card-metric card d-flex flex-column"
    //     style={{
    //       borderRadius: "10px",
    //       border: "none",
    //       height: "100%", // Ensure the card takes full height of the container
    //     }}
    //   >
    //     <div className="card-body d-flex flex-column justify-content-between">
    //       {/* Title */}
    //       <div className="text-muted card-title h5">{title}</div>

    //       {/* Value */}
    //       <h4 className="display-6">
    //         {currency ? `IDR ${value.toLocaleString()}` : value}
    //       </h4>

    //       {/* Comparison or Percentage Change */}
    //       {comparison && (
    //         <p
    //           className={`text-${comparison.change >= 0 ? "success" : "danger"}`}
    //         >
    //           {comparison.change >= 0
    //             ? `+${comparison.change}%`
    //             : `${comparison.change}%`}{" "}
    //           {comparison.message}
    //         </p>
    //       )}
    //     </div>
    //   </div>
    // </div>
    <table className="table">
      <tbody>
        <tr>
          <td className="text-muted ">{title}</td>
          <td className=" text-end">
            {currency ? `IDR ${value.toLocaleString()}` : value}
          </td>
        </tr>
      </tbody>
    </table>
  );
};

// Report Card Component
const ReportCard = () => {
  // Example of data for the report card
  const reportData = [
    {
      title: "Total Data",
      value: 1897,
      currency: false, // No currency for this value
    },
    {
      title: "Total Jumlah Order Produk",
      value: 1897,
      currency: false,
    },
    {
      title: "Total Order",
      value: 888270000, // IDR
      currency: true,
    },
    {
      title: "Total Komisi",
      value: 154270000, // IDR
      currency: true,
    },
    {
      title: "Total Order Setelah Komisi",
      value: 734000000, // IDR
      currency: true,
    },
  ];

  return (
    <div className="row justify-content-center mb-3">
      <div className="col-12 mb-3">
        <div
          className="shadow-sm card-metric card d-flex flex-column p-0"
          style={{
            borderRadius: "10px",
            border: "none",
            height: "100%", // Ensure the card takes full height of the container
          }}
        >
          {/* table header */}
          <div className="card-header ">
            <h2 className="m-0">Total Data</h2>
          </div>
          {reportData.map((data, index) => (
            <MetricCard
              key={index}
              title={data.title}
              value={data.value}
              currency={data.currency}
              comparison={data.comparison}
            />
          ))}
        </div>
      </div>
    </div>
  );
};

// Table Component (Updated)
const OrderTable = ({ orders, handleDelete }) => {
  return (
    <div className="table-responsive">
      <table className="table table-hover table-vcenter">
        <thead>
          <tr>
            <th>Order #</th>
            <th>Pelanggan</th>
            <th>Jumlah Tamu</th>
            <th>Nama Agen</th>
            <th>Tanggal Pemesanan</th>
            <th>Sesi</th>
            <th>Total Penjualan</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {orders.map((order, index) => (
            <tr key={index}>
              <td>{order.orderNumber}</td>
              <td>{order.customerName}</td>
              <td>{order.guestCount}</td>
              <td>{order.agentName}</td>
              <td>{order.orderDate}</td>
              <td>{order.session}</td>
              <td>IDR {order.totalSales.toLocaleString()}</td>
              <td>{order.status}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

// Main Page Component
const LaporanProduk = () => {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);

  const queryString = buildQueryString({
    search: search || "",
    page: currentPage,
    limit: LIMIT_DATA_PER_PAGE,
  });

  useFetchData(`/orders${queryString}`, "orders");
  const { deleteData } = useDeleteData("/orders", "orders", queryString);

  const { state } = useContext(AppContext);

  // Example order data
  const orders = [
    {
      orderNumber: "24120010",
      customerName: "Komang Gede",
      guestCount: 5,
      agentName: "John Doe",
      orderDate: "2024-12-13",
      session: "Sesi 5",
      totalSales: 1000000,
      status: "Completed",
    },
    {
      orderNumber: "24120011",
      customerName: "Dewi Ratna",
      guestCount: 3,
      agentName: "Jane Smith",
      orderDate: "2024-12-14",
      session: "Sesi 6",
      totalSales: 1500000,
      status: "Pending",
    },
  ];

  const handleDelete = (e, id) => {
    e.stopPropagation();
    deleteData(id);
  };

  const { handleSuccess, handleError, showCanvasHandler } = useCanvasHandler();

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setSearch(e.target.value);
    }
  };

  const totalPages = orders.length > 0 ? 1 : 0;

  const Pagination = usePaginationWithComponent({
    totalPages,
    currentPage,
    onPageChange: setCurrentPage,
    visiblePages: 5, // Optional: number of visible pages in pagination (default is 5)
  });

  if (orders.loading) return <FullLoader />;
  if (orders.error) return <Suspense error={orders.error} />;

  return (
    <LayoutDashboard>
      <div className="container-fluid mt-5">
        {/* Report Card */}
      <h1>Laporan Produk</h1>

        <ReportCard />

        {/* Search Button */}
        <div className="table-container vh-100">
          <div className="search-container mb-3">
            {/* <SearchInput handleSearch={handleSearch} defaultValue={search} /> */}
          </div>

          {/* Orders Table */}
          <OrderTable orders={orders} handleDelete={handleDelete} />

          {/* Pagination */}
          <div className="mt-4">{Pagination}</div>
        </div>
      </div>
    </LayoutDashboard>
  );
};

export default LaporanProduk;
